// extracted by mini-css-extract-plugin
module.exports = {"clickable-container":"clickable-container-component_clickable-container__30RKd","container":"clickable-container-component_container__1FcYR"};